import Phaser from "phaser";

export type AnimationStateDefinition = {
  frameRate: number;
  repeat: number;
  frames: number;
  directions: readonly string[];
};

export type AnimationProfile = {
  id: string;
  atlasKey: string;
  prefix: string;
  zeroPad: number;
  states: Record<string, AnimationStateDefinition>;
};

export function registerAnimationProfile(scene: Phaser.Scene, profile: AnimationProfile): void {
  for (const [state, definition] of Object.entries(profile.states)) {
    for (const direction of definition.directions) {
      const key = `${profile.id}-${state}-${direction}`;
      if (scene.anims.exists(key)) continue;

      scene.anims.create({
        key,
        frames: scene.anims.generateFrameNames(profile.atlasKey, {
          prefix: `${profile.prefix}${state}_${direction}_`,
          start: 0,
          end: definition.frames - 1,
          zeroPad: profile.zeroPad,
        }),
        frameRate: definition.frameRate,
        repeat: definition.repeat,
      });
    }
  }
}
